export default {
  analyticsId: 'UA-144064030-1'
};
